import { isEqual } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Custom hook for managing association state with deep comparison
 */
export const useAssociationState = (associations, activeAssociationKeys) => {
  const getInitialState = useCallback(() => {
    return activeAssociationKeys.reduce((acc, key) => {
      acc[key] = associations?.[key] || [];
      return acc;
    }, {});
  }, [associations, activeAssociationKeys]);

  const [associationIds, setAssociationIds] = useState(getInitialState);
  const prevAssociationsRef = useRef(associations);

  // Only update when associations actually change (deep comparison)
  useEffect(() => {
    if (!isEqual(prevAssociationsRef.current, associations)) {
      prevAssociationsRef.current = associations;
      setAssociationIds(getInitialState());
    }
  }, [associations, getInitialState]);

  return [associationIds, setAssociationIds];
};
